// extracted by mini-css-extract-plugin
export default {"iconButton":"extra-info-actions_iconButton__cv75E","copyButton":"extra-info-actions_copyButton__erk7P"};